__turbopack_context__.v({
  "body": "XwZXtG_body",
  "card": "XwZXtG_card",
  "gridWrapperWide": "XwZXtG_gridWrapperWide",
  "gridWrapperWideSpaceBetween": "XwZXtG_gridWrapperWideSpaceBetween",
  "heading": "XwZXtG_heading",
  "noMargin": "XwZXtG_noMargin",
  "verticallyCentered": "XwZXtG_verticallyCentered",
});
